import { Component } from '@angular/core';

@Component({
    selector: 'app-todays-revenue',
    standalone: true,
    imports: [],
    templateUrl: './todays-revenue.component.html',
    styleUrl: './todays-revenue.component.scss'
})
export class TodaysRevenueComponent {}